import axios from 'axios'

export default axios.create({
    // baseURL:"https://seahorse-app-odvb2.ondigitalocean.app",
    // baseURL: "http://localhost:8001/meesho/",
    baseURL: "https://reward-day-bg984.ondigitalocean.app/meesho/",

})